var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEarthIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_768_1931)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.5 9.99998C17.5 8.51588 17.0597 7.06514 16.2348 5.83139C15.4099 4.59765 14.2375 3.63637 12.8661 3.06923C11.4946 2.50209 9.98571 2.35459 8.53038 2.6454C7.07504 2.93621 5.73871 3.65226 4.69051 4.7029C3.64232 5.75355 2.9294 7.09155 2.64199 8.54756C2.35458 10.0036 2.5056 11.5121 3.07594 12.8823C3.64628 14.2524 4.6103 15.4225 5.84597 16.2445C7.08164 17.0665 8.5334 17.5034 10.0175 17.5",
    stroke: "white",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3 7.5H17",
    stroke: "white",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3 12.5H10.4167",
    stroke: "white",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.58566 2.5C8.18178 4.74968 7.4375 7.34822 7.4375 10C7.4375 12.6518 8.18178 15.2503 9.58566 17.5",
    stroke: "white",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.418 2.5C12.0295 5.0815 12.7664 8.11349 12.5196 11.1467",
    stroke: "white",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.168 15.8307C14.168 16.2728 14.3436 16.6967 14.6561 17.0092C14.9687 17.3218 15.3926 17.4974 15.8346 17.4974C16.2767 17.4974 16.7006 17.3218 17.0131 17.0092C17.3257 16.6967 17.5013 16.2728 17.5013 15.8307C17.5013 15.3887 17.3257 14.9648 17.0131 14.6522C16.7006 14.3397 16.2767 14.1641 15.8346 14.1641C15.3926 14.1641 14.9687 14.3397 14.6561 14.6522C14.3436 14.9648 14.168 15.3887 14.168 15.8307Z",
    stroke: "white",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.8359 12.9141V14.1641",
    stroke: "white",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.8359 17.5V18.75",
    stroke: "white",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.3598 14.375L17.2773 15",
    stroke: "white",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.3919 16.6641L13.3086 17.2891",
    stroke: "white",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.3086 14.375L14.3919 15",
    stroke: "white",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.2773 16.6641L18.3607 17.2891",
    stroke: "white",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_768_1931"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEarthIcon);
export default __webpack_public_path__ + "static/media/earth-icon.a83ebcde03aa4040a825adee2d9ab550.svg";
export { ForwardRef as ReactComponent };